import { Skeleton } from '@sea-snag/ui';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

import { SeasonProgressGoals } from '../../components/revenue/season-progress-goals';
import { useRequiredOrganization } from '../../hooks/use-required-organization';
import { useYear } from '../../hooks/use-year';

// Goals: each boat's revenue and booked weeks against its goal, and the goals
// themselves, edited in the same table (#205; called Season Progress until
// 22 Oct). `edit` opens it with the goals ready to edit, as every "Set goal"
// link does.
const searchSchema = z.object({
  edit: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute('/$orgPid/analytics/goals')({
  component: AnalyticsGoalsTab,
  validateSearch: searchSchema,
});

function AnalyticsGoalsTab() {
  const { organization, isLoading } = useRequiredOrganization();
  const { edit } = Route.useSearch();
  const year = useYear();
  const navigate = useNavigate();
  const orgPid = organization?.pid ?? '';

  if (isLoading || !orgPid) return <Skeleton className="h-[600px] w-full" />;
  // Leaving the edit mode drops `edit` from the address, so a reload doesn't reopen it.
  const stopEditing = edit
    ? () =>
        void navigate({ to: '.', search: (prev) => ({ ...prev, edit: undefined }), replace: true })
    : undefined;
  // Keyed by year: switching years starts clean, so an unsaved edit can't be
  // saved into the other year.
  return (
    <SeasonProgressGoals
      key={year}
      orgPid={orgPid}
      year={year}
      startEditing={edit === true}
      onStopEditing={stopEditing}
    />
  );
}
